// React
import React, { useEffect, useState } from 'react';

// Containers Injection
import { BillsToReceiveInjection } from '../../containers/billsToReceiveInjection';

// Yup & Formik
import * as Yup from 'yup';
import { useFormik } from 'formik';

// Helpers
import { useLoading } from '../../../../hook/useLoading';
import { APIClient } from '../../../../helpers/api_helper';

// View
import { BillsToReciveListPage } from './view';
import { BillsToReceiveForm } from '../billsToReceiveForm';

export const BillsToReciveList = () => {
  const [filter, setFilter] = useState('');
  const [isOpen, setIsOpen] = useState(false);
  const [isPartial, setIsPartial] = useState(false);
  const [periodFilter, setPeriodFilter] = useState([]);
  const [selectedFile, setSelectedFile] = useState([]);
  const [billsByHash, setBillsByHash] = useState(null);
  const [isConfirmAction, setIsConfirmAction] = useState(false);

  const date = new Date();
  const api = new APIClient();
  const { loadingWithTime } = useLoading();

  let firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
  let lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);

  const { bills, summary, success, getBillsToPay, deleteBillsToPay, loading } =
    BillsToReceiveInjection();

  const toggle = () => {
    setIsOpen((prevState) => !prevState);
  };

  const getBillsToReceiveByHash = async (hash) => {
    const bills = await api.get(`/financial/${hash}`);

    if (bills) {
      setBillsByHash(bills);
      setSelectedFile(bills.files.length > 0 && bills.files);
    }
  };

  const handleEdit = (values, isConfirmAction) => {
    loadingWithTime(1000);

    setIsConfirmAction(isConfirmAction);

    const { id } = values;

    getBillsToReceiveByHash(id);

    setTimeout(() => {
      toggle();
    }, 1000);
  };

  const handleDelete = (id) => {
    deleteBillsToPay(id);
  };

  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      starts: firstDay.toISOString().slice(0, 10),
      ends: lastDay.toISOString().slice(0, 10),
    },

    validationSchema: Yup.object().shape({
      starts: Yup.string().nullable(),
      ends: Yup.string().nullable(),
    }),

    onSubmit: (values) => {
      loadingWithTime(1000);
      setPeriodFilter([values.starts, values.ends]);
    },
  });

  const columns = [
    {
      name: <span className="font-weight-bold fs-13">Vencimento</span>,
      sortable: true,
      selector: (cell) => cell.due_date,
    },
    {
      name: <span className="font-weight-bold fs-13">Organização</span>,
      selector: (row) => row.organization_name,
      sortable: true,
    },
    {
      name: <span className="font-weight-bold fs-13">Categoria</span>,
      selector: (row) => row.financial_category_name,
      sortable: true,
    },
    {
      name: <span className="font-weight-bold fs-13">Descrição</span>,
      selector: (row) => row.description,
      sortable: true,
      width: '20%',
    },
    {
      name: <span className="font-weight-bold fs-13">Valor</span>,
      selector: (row) =>
        row.value.toLocaleString('pt-br', {
          style: 'currency',
          currency: 'BRL',
        }),
      sortable: true,
    },
    {
      name: <span className="font-weight-bold fs-13">Situação</span>,
      selector: (row) => {
        return (
          <div className="d-flex gap-1">
            <i
              className="ri-checkbox-blank-circle-fill fs-18"
              style={{
                color: row.status.color,
              }}
            ></i>
            <span>
              <small>{row?.status?.title}</small>
            </span>
          </div>
        );
      },
    },
  ];

  useEffect(() => {
    getBillsToPay(periodFilter, filter, 'r');
  }, [success, periodFilter, filter]);

  return (
    <React.Fragment>
      <BillsToReciveListPage
        // data
        bills={bills}
        summary={summary}
        loading={loading}
        // helpers
        toggle={toggle}
        filter={filter}
        columns={columns}
        setFilter={setFilter}
        validation={validation}
        handleEdit={handleEdit}
        handleDelete={handleDelete}
        setBillsByHash={setBillsByHash}
        setSelectedFile={setSelectedFile}
        setIsConfirmAction={setIsConfirmAction}
      />

      <BillsToReceiveForm
        toggle={toggle}
        isOpen={isOpen}
        isPartial={isPartial}
        setIsPartial={setIsPartial}
        selectedFile={selectedFile}
        setBillsByHash={setBillsByHash}
        setSelectedFile={setSelectedFile}
        billsByHash={billsByHash || null}
        isConfirmAction={isConfirmAction}
        setIsConfirmAction={setIsConfirmAction}
      />
    </React.Fragment>
  );
};
